"use client";

import { motion } from "framer-motion";

import { crossfadeVariants } from "@/lib/animations";
import { cn } from "@/lib/utils";

const widths = ["w-11", "w-16", "w-14", "w-20", "w-16", "w-12"];

interface TagChipsSkeletonProps {
  className?: string;
}

export function TagChipsSkeleton({ className }: TagChipsSkeletonProps) {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={crossfadeVariants}
      className={cn(
        "-mx-4 flex gap-2 overflow-x-auto px-4 pb-2 scrollbar-none md:mx-0 md:flex-wrap md:overflow-visible md:px-0",
        className
      )}
    >
      {widths.map((w, i) => (
        <div key={i} className={cn("h-[34px] shrink-0 animate-pulse rounded-full bg-muted", w)} />
      ))}
    </motion.div>
  );
}
